import React from 'react';
import { Link } from 'react-router-dom';
import Recruiting from '../icons/Recuritment & Staffing.svg';
import EmployeeTraining from '../icons/Employee Training.svg';
import HRPolicy from '../icons/Hr Policy Development.svg';
import Compesation from '../icons/Compensation & Benifits.svg';
import EmployeeRelation from '../icons/employee relation.svg';
import HRTechnology from '../icons/hr technology.svg';
import HRConsulting from '../icons/Hr Consulting_.svg';

const services = [
  {
    icon: Recruiting,
    title: 'Recruitment & Staffing',
    description: 'Our recruitment and staffing services focus on acquiring top talent through effective talent acquisition, executive search, and flexible staffing solutions. We streamline the hiring process to match you with the best candidates quickly and efficiently.',
    href: '/recruitment-staffing'
  },
  {
    icon: EmployeeTraining,
    title: 'Employee Training & Development',
    description: 'We provide customized employee training and development programs to advance skills and support career growth. Our offerings include targeted training sessions, performance management, and career development initiatives to enhance overall employee performance.',
    href: '/employee-training'
  },
  {
    icon: HRPolicy,
    title: 'HR Policy Development',
    description: 'Our team specializes in HR policy development, including crafting detailed policies, developing employee handbooks, and offering compliance guidance. We create robust policies that are legally compliant and aligned with your organizational objectives.',
    href: '/hr-policy'
  },
  {
    icon: Compesation,
    title: 'Compensation & Benefits',
    description: 'Our compensation and benefits services design effective compensation strategies and manage benefits administration. We develop incentive and bonus plans to attract, retain, and reward top talent while ensuring fair and competitive compensation structures.',
    href:'/compensation-benefits'
  },
  {
    icon: EmployeeRelation,
    title: 'Employee Relations & Workplace Culture',
    description: 'We focus on improving employee relations and fostering a positive workplace culture through conflict resolution, employee engagement initiatives, and diversity and inclusion efforts. Our services aim to create a supportive and productive work environment.',
    href:'/employee-relations'
  },
  {
    icon: HRTechnology,
    title: 'HR Technology & Systems',
    description: 'We implement and manage advanced HR technology and systems, such as HRIS, ATS, and employee self-service portals. Our solutions streamline HR operations and enhance efficiency in handling employee information and recruitment processes.',
    href:'/hr-technology'
  },
  {
    icon: HRConsulting,
    title: 'HR Consulting & Outsourcing',
    description: 'We offer expert HR consulting and outsourcing services to address your HR needs with strategic guidance and managed solutions. Our consulting services and outsourcing options enhance HR operations and ensure compliance with industry standards.',
    href:'/hr-consulting'
  },
];

const SubServiceSectionHR = () => {

  return (
    <section className="bg-white py-12 px-4">
    <div className="container mx-auto px-4">
      <div className="flex flex-wrap -mx-4">
        {services.map((service, index) => (
          <div
            key={index}
            className="w-full md:w-1/2 lg:w-1/4 mb-8"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="flex flex-col justify-between items-center text-center bg-white rounded-lg py-12 px-4 transform transition hover:-translate-y-2 hover:shadow-lg border border-[#13689b] mx-2 h-full">
              <div className="flex-grow">
              <img src={service.icon} alt = {service.title} className='mx-auto' />
                <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                <p className="text-left text-black">{service.description}</p>
              </div>
              <Link to={service.href} className='text-white bg-[#13689b] mt-4 px-3 py-2 rounded-md font-semibold hover:text-[#13689b] hover:bg-white hover:border hover:border-[#13689b]'>Explore Service</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
  
  );
};

export default SubServiceSectionHR;
